module.exports = __webpack_public_path__ + "img/welcome-to-apvertise-p-1080.bcf39e50.png";